import Hero from '../components/Hero';
import WhyUs from '../components/WhyUs';
import ServicesSection from '../components/ServicesSection';
import PremiumServicesSection from '../components/PremiumServicesSection';
import HowWeWorkSection from '../components/HowWeWorkSection';
import TemplatesSection from '../components/TemplatesSection';
import TargetSectorsSection from '../components/TargetSectorsSection';
import ClientsPartnersSection from '../components/ClientsPartnersSection';
import KnowledgeTicker from '../components/KnowledgeTicker';
import { FEATURES } from '../components/featureFlags';
import { motion } from 'framer-motion';
import { ArrowLeft } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

const HomePage = () => (
  <main data-testid="home-page">
    {/* 1. Hero */}
    <Hero />

    {/* 1.b Knowledge Ticker — silent latest-articles marquee (renders nothing until content is published) */}
    <KnowledgeTicker />

    {/* 2. Value / Why Child Horizons */}
    <WhyUs />

    {/* 3. Core Consulting Services */}
    <ServicesSection />

    {/* 3.b Premium Services — high-value specialised engagements */}
    <PremiumServicesSection />

    {/* 4. How We Work — methodology */}
    <HowWeWorkSection />

    {/* 5. Target sectors — where our work lands */}
    <TargetSectorsSection />

    {/* 6. Professional Resources */}
    <div id="templates">
      <TemplatesSection />
    </div>

    {/* 7. Clients & Partners (hidden by default — enable via FEATURES.SHOW_CLIENTS_PARTNERS) */}
    {FEATURES.SHOW_CLIENTS_PARTNERS && <ClientsPartnersSection />}

    {/* 8. Consultation CTA */}
    <section data-testid="cta-section" className="py-24 bg-[#1F3D2B]" dir="rtl">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-flex items-center gap-2 text-[11px] font-medium tracking-[0.2em] text-[#A8B596] uppercase mb-5">
            <span className="w-8 h-px bg-[#A8B596]" />
            جاهزون لخدمتكم
          </span>
          <h2
            className="font-['Noto_Kufi_Arabic'] font-bold text-white text-[26px] sm:text-4xl md:text-[44px] lg:text-[52px] leading-[1.5] sm:leading-[1.45] md:leading-[1.4] mb-6 mx-auto max-w-[18ch] px-2"
            style={{ letterSpacing: '0.005em', wordSpacing: '0.03em' }}
          >
            هل تحتاج إلى دعم مهني في تطوير منشأتك؟
          </h2>
          <p className="text-base sm:text-lg text-[#D8E0C9] mb-10 max-w-2xl mx-auto leading-9">
            احجز جلسة استشارية مع فريقنا لمناقشة احتياج منشأتك ورسم خارطة عمل واضحة للخطوات القادمة.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center max-w-md mx-auto sm:max-w-none">
            <Link to="/booking" className="w-full sm:w-auto">
              <button
                data-testid="cta-booking-btn"
                className="w-full bg-white text-[#1F3D2B] hover:bg-[#F5F2EC] px-8 py-4 rounded-2xl font-bold flex items-center justify-center gap-2 transition-colors tracking-tight"
              >
                احجز جلسة استشارية
                <ArrowLeft size={18} className="rtl-flip" />
              </button>
            </Link>
            <Link to="/quotation" className="w-full sm:w-auto">
              <button
                data-testid="cta-store-btn"
                className="w-full border border-white/40 text-white hover:bg-white/10 px-8 py-4 rounded-2xl font-semibold transition-colors tracking-tight"
              >
                اطلب عرض سعر
              </button>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  </main>
);

export default HomePage;
